const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Grouped Date range", "uipress-lite"),
  moduleName: "uip-grouped-date-range",
  description: __("Outputs a grouped date picker. This date picker is used for controlling it's siblings range such as analytic blocks.", "uipress-lite"),
  group: "dynamic",
  icon: "event",
};
